import { render, staticRenderFns } from "./BadgeCategoryIds.vue?vue&type=template&id=246d98f3&"
import script from "./BadgeCategoryIds.vue?vue&type=script&lang=ts&"
export * from "./BadgeCategoryIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports